import React, { Component } from "react";
import "./MappedPointDebug.scss";
import AdminActions from "../../actions/adminActions";
import AdminStore from "../../stores/adminStore";
import BuildingActions from "../../actions/buildingActions";
import BuildingStore from "../../stores/buildingStore";
import GeneralStore from "../../stores/generalStore";
import { LogoSpinner } from "../../components/LogoSpinner";
import { HighChart } from "../../components/HighChart";
import { SearchSelect } from "../../components/SearchSelect";
import { DocumentTitle } from "../../components/DocumentTitle";
import _ from "lodash";

class MappedPointDebug extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ts_start: GeneralStore.getStartDate(),
      ts_end: GeneralStore.getEndDate(),

      selected_mapping: null,
      selected_source: null,
      selected_source_type: null,
      selected_building: null,
      available_buildings: BuildingStore.getBuildings(),
      data_source_mappings: AdminStore.getDataSourceMappings(),
      available_appliances: AdminStore.getAvailableAppliances(),
      available_counters: AdminStore.getAvailableCounters(),
      available_sensors: AdminStore.getAvailableSensors(),
      available_types: [
        {
          name: "Sensors",
          value: "Sensor",
        },
        {
          name: "Appliances",
          value: "Appliance",
        },
        {
          name: "Counters",
          value: "Counter",
        },
      ],
      searchInput: "",
      loading: true,
    };
    this._selectBuilding = this._selectBuilding.bind(this);
    this._onDateChange = this._onDateChange.bind(this);
    this._onDataChange = this._onDataChange.bind(this);
    this.onFilterInput = this.onFilterInput.bind(this);
    this._selectSource = this._selectSource.bind(this);
    this._selectSourceType = this._selectSourceType.bind(this);
    this._selectMapping = this._selectMapping.bind(this);
  }
  _onDataChange() {
    this.setState({
      data_source_mappings: AdminStore.getDataSourceMappings(),
      available_counters: AdminStore.getAvailableCounters(),
      available_sensors: AdminStore.getAvailableSensors(),
      available_appliances: AdminStore.getAvailableAppliances(),
      chart_data: AdminStore.getMappedPointValues(),
      loading: false,
    });
  }
  componentWillMount() {
    GeneralStore.addChangeListener(this._onDateChange);
    AdminStore.addChangeListener(this._onDataChange);
  }
  componentWillUnmount() {
    AdminStore.clear();
    GeneralStore.removeChangeListener(this._onDateChange);
    AdminStore.removeChangeListener(this._onDataChange);
  }
  componentDidMount() {
    this.fetchBuildings();
  }
  async fetchBuildings() {
    const buildings = await BuildingActions.getBuildings();
    this.setState({
      available_buildings: buildings,
      loading: false,
    });
  }

  _selectBuilding(selected_building) {
    this.setState(
      {
        selected_building,
        selected_source: null,
        selected_source_type: null,
        searchInput: "",
      },
      this._fetchDataSources(selected_building.building_id)
    );
  }

  _fetchMappings(datasourceId, ts_start, ts_end) {
    this.setState({ loading: true });
    AdminActions.getDataSourceMappings(datasourceId, ts_start, ts_end);
  }
  _fetchDataSources(building_id) {
    this.setState({ loading: true });
    AdminActions.getBuildingDatasources(building_id);
  }
  _onDateChange() {
    const ts_start = GeneralStore.getStartDate();
    const ts_end = GeneralStore.getEndDate();

    this.setState(
      {
        ts_start,
        ts_end,
      },
      () => {
        if (this.state.selected_source !== null) {
          this._fetchMappings(this.state.selected_source.value);
          if (this.state.selected_mapping != null) {
            AdminActions.getMappedPointValues(
              this.state.selected_mapping.mapping_id,
              ts_start,
              ts_end
            );
          }
        }
      }
    );
  }

  _selectSourceType(selected_source_type) {
    this.setState({
      selected_source_type: selected_source_type,
      selected_source: null,
      searchInput: "",
    });
  }
  _selectSource(selected_source) {
    if (selected_source !== null) {
      this._fetchMappings(selected_source.value);
    }
    this.setState({ selected_source: selected_source, searchInput: "" });
  }
  onFilterInput(event) {
    this.setState({ searchInput: event.target.value });
  }
  getTableHeader() {
    return (
      <thead>
        <tr>
          <th
            className="wd-30p tx-mont tx-medium"
            style={{ cursor: "pointer" }}
          >
            Name
          </th>
          <th className="wd-30p tx-10-force tx-mont tx-medium tx-center">
            Description
          </th>
          <th className="wd-30p tx-10-force tx-mont tx-medium tx-center">
            Mapped To
          </th>
          <th className="wd-10p tx-10-force tx-mont tx-medium tx-center">
            Unit
          </th>
        </tr>
      </thead>
    );
  }
  _selectMapping(mapping) {
    AdminActions.getMappedPointValues(
      mapping.mapping_id,
      this.state.ts_start,
      this.state.ts_end
    );
    this.setState({ selected_mapping: mapping });
  }
  getPointRows() {
    let searchValue = this.state.searchInput;
    let displayMappings = this.state.data_source_mappings;

    if (this.state.searchInput && this.state.searchInput.length > 0) {
      displayMappings = _.filter(displayMappings, function (obj) {
        return (
          obj.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 ||
          obj.description.toLowerCase().indexOf(searchValue.toLowerCase()) !==
            -1
        );
      });
    }
    if (displayMappings.length === 0) {
      return (
        <tr>
          <td className="valign-middle">
            <div className="d-flex align-items-center">
              <div>
                <div className="tx-inverse">No mappings available.</div>
              </div>
            </div>
          </td>
          <td className="valign-middle tx-center"></td>
          <td className="valign-middle tx-center"></td>
          <td className="valign-middle tx-center"></td>
        </tr>
      );
    } else {
      return displayMappings.map((mapping, key) => {
        return (
          <tr
            key={key}
            className="hover-row"
            onClick={() => this._selectMapping(mapping)}
          >
            <td className="valign-middle">
              <div className="d-flex align-items-center">
                <div>
                  <div className="tx-inverse">{mapping.name}</div>
                </div>
              </div>
            </td>
            <td className="valign-middle tx-center">{mapping.description}</td>
            <td className="valign-middle tx-center">
              {mapping.entity_type.entity_type} - {mapping.entity_type.name}
            </td>
            <td className="valign-middle tx-center">{mapping.unit}</td>
          </tr>
        );
      });
    }
  }
  getPointChart() {
    let chart_data = this.state.chart_data;
    let chart_id = "DebugChart1";
    let title = "Select A Point";
    if (chart_data && chart_data.length > 0) {
      title = chart_data[0].name;
      return (
        <div className="row mg-t-20">
          <div className="col-12 col-sm-12">
            <div className="card bd-0 shadow-base">
              {this.getChartHeaderContent(title)}
              <div
                className="card-body bd pd-b-0"
                style={{ backgroundColor: "#fff", height: "230px" }}
              >
                <HighChart
                  main_type="line"
                  exporting={true}
                  series={chart_data}
                  dataType={""}
                  chart_Tag={chart_id}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  getChartHeaderContent(title) {
    return (
      <div className="card-header bg-transparent pd-x-25 pd-y-15 bd d-flex justify-content-between align-items-center">
        <div style={{ float: "left" }}>
          <h6
            className="card-title tx-uppercase tx-12 mg-b-0"
            style={{ float: "left", marginTop: "6px" }}
          >
            {title}
          </h6>
        </div>
      </div>
    );
  }
  render() {
    let data_sources = [];
    if (this.state.selected_source_type) {
      if (this.state.selected_source_type.value === "Appliance") {
        data_sources = this.state.available_appliances;
      }
      if (this.state.selected_source_type.value === "Sensor") {
        data_sources = this.state.available_sensors;
      }
      if (this.state.selected_source_type.value === "Counter") {
        data_sources = this.state.available_counters;
      }
    }
    const list_shown = this.state.selected_source;

    return (
      <div
        className="br-mainpanel br-profile-body floorplan-background"
        id="MappedPointDebug"
      >
        <DocumentTitle title={"Mapped Point Debug"} />
        <LogoSpinner loading={this.state.loading} />
        <div className="br-container">
          <div className="row">
            <div className="col mg-t-15">
              <div className="card pd-30 mg-t-30 shadow-base bd-0 mg-t-10">
                <div className="row">
                  <div className="col-12 col-sm-12">
                    <div className="row pd-t-6">
                      <div className="col-12 col-sm-4">
                        <SearchSelect
                          limit={999}
                          options={this.state.available_buildings}
                          placeholder={"Select Building..."}
                          defaultValue={this.state.selected_building}
                          actionOnSelectedOption={this._selectBuilding}
                        />
                      </div>
                      <div className="col-12 col-sm-4">
                        <SearchSelect
                          limit={3}
                          options={this.state.available_types}
                          placeholder={"Select Data Source type..."}
                          defaultValue={this.state.selected_source_type}
                          actionOnSelectedOption={this._selectSourceType}
                        />
                      </div>
                      <div className="col-12 col-sm-4">
                        <SearchSelect
                          limit={30}
                          options={data_sources}
                          placeholder={"Select Data Source..."}
                          defaultValue={this.state.selected_source}
                          actionOnSelectedOption={this._selectSource}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {list_shown ? (
                  <div className="row mg-b-5">
                    <div className="col-12 col-sm-12">
                      <hr />
                      <div className="bd-0 mg-t-10">
                        <div
                          className="bd-0 pd-b-0 pd-t-0"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <div className="row mg-t-10">
                            <div
                              className="col-12 col-sm-12"
                              style={{ marginBottom: "5px", marginTop: "5px" }}
                            >
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text">
                                    <ion-icon name="search" size="small" />
                                  </span>
                                </div>
                                <input
                                  defaultValue={this.state.searchInput}
                                  type="text"
                                  className="form-control"
                                  placeholder="Filter by name and description"
                                  onChange={this.onFilterInput}
                                />
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div
                            className="row mg-t-10 mg-b-5"
                            style={{ maxHeight: "230px", overflowY: "scroll" }}
                          >
                            <div
                              className="col-12"
                              style={{ marginBottom: "5px", marginTop: "5px" }}
                            >
                              <table className="table mg-b-0 table-contact">
                                {this.getTableHeader()}
                                <tbody>{this.getPointRows()}</tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row mg-t-10">
                    <div className="col-12 col-sm-12 col-md-12 mg-b-15">
                      <div className="card bd-0 shadow-base">
                        <div
                          className="card-body bd pd-b-0 pd-t-0"
                          style={{
                            backgroundColor: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "60px 0",
                          }}
                        >
                          <h4 className="tx-bold mg-b-20 tx-center">
                            Mapped Point Debug
                          </h4>
                          <p className="mg-x-20 tx-center">
                            <ion-icon
                              name="construct"
                              style={{ fontSize: "48px" }}
                            />
                          </p>
                          <h4 className="tx-default tx-center">
                            Please select the building and data source to filter
                            points from.
                          </h4>
                          <p className="tx-center">
                            Once all selections are made then the available data
                            points will populate.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.getPointChart()}
        </div>
      </div>
    );
  }
}

export default MappedPointDebug;
